import React from 'react';
import Button from '../Button';
import styled from 'styled-components';
import { breakpoints } from '../../utils/styles';

const StyledButton = styled(Button)``;

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
  margin: 0 auto;
  max-width: 200px;

  @media screen and (min-width: ${breakpoints.desktop}px) {
    flex-direction: row;
    max-width: none;
  }
`;

interface Props {
  baseUrl: string;
  timeLimit: number | null;
  onChange?: (newLimit: number) => void;
}

function NowPageSidebar(props: Props) {
  return <React.Fragment>
{/*     <BackButton/> */}
    <div className='text-center'>
      <p>Configura la cantidad de minutos para ver las próximas películas</p>
      <Buttons className="px-5 py-3">
        {renderTimeButtons(props)}
      </Buttons>
    </div>
  </React.Fragment>;
}

function renderTimeButtons(props: Props) {
  const result:any[] = [];

  for (let i = 30; i <= 180; i = i + 30) {
    result.push(<StyledButton
      to={props.baseUrl + '/minutos-' + i}
      primary={i === props.timeLimit}
      small
      onClick={props.onChange}
    >
        {i}'
    </StyledButton>);
  }

  return result;
}

export default NowPageSidebar;